export default __webpack_public_path__ + "3157521f091ec9aa8ee977cb0c58271a.png";